var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-total"},[_c('div',[_vm._v(_vm._s(_vm.total)+"个查询结果")]),_vm._t("btn")],2)}
var staticRenderFns = []

export { render, staticRenderFns }